import React from 'react';
import { Form, Select, Input, DatePicker } from 'antd';
import moment from 'moment';
import locale from 'antd/lib/date-picker/locale/ru_RU';
import filterConnect from '../../../../../../common/hoc/filterConnect';

const Option = Select.Option;

class DriverLicense extends React.PureComponent {
  startDateDoc = value => {
    // Действительно до
    return value.format('x') < moment().format('x') - 43000;
  };

  getCategoryByKey = key => {
    return (
      this.props.vehicleCategories &&
      this.props.vehicleCategories.find(item => item.categoryKey === key)
    );
  };

  getSelectedСategories(categories) {
    if (categories) {
      return categories
        .map(key => {
          return this.getCategoryByKey(key);
        })
        .filter(item => item);
    }
    return [];
  }

  render() {
    let { isEditable, validateField, form, vehicleCategories } = this.props;

    const { getFieldDecorator, getFieldValue } = form;

    const validateDriverLicense = validateField('driverLicense');
    const validateDriverLicenseEndDate = validateField('driverLicenseEndDate');
    const validateDriverLicenseСategories = validateField(
      'driverLicenseСategories'
    );

    const selectedСategories = this.getSelectedСategories(
      getFieldValue('driverLicenseСategories')
    );
    return (
      <div className="b-form-fields">
        <div className="b-form-fields__item">
          <Form.Item
            label="Водительское удостоверение"
            validateStatus={validateDriverLicense.status}
            help={validateDriverLicense.help}
          >
            {getFieldDecorator('driverLicense')(
              <Input
                name="driverLicense"
                style={{ width: 368 }}
                placeholder="Серия и номер ВУ"
                disabled={!isEditable}
              />
            )}
          </Form.Item>
        </div>
        <div className="b-form-fields__item">
          <Form.Item
            label="Действительно до"
            validateStatus={validateDriverLicenseEndDate.status}
            help={validateDriverLicenseEndDate.help}
          >
            {getFieldDecorator('driverLicenseEndDate')(
              <DatePicker
                name="driverLicenseEndDate"
                style={{ width: 224 }}
                placeholder="ДД.ММ.ГГГГ"
                format={'DD.MM.YYYY'}
                disabled={!isEditable}
                disabledDate={this.startDateDoc}
                locale={locale}
              />
            )}
          </Form.Item>
        </div>
        <div className="b-form-fields__item">
          <Form.Item
            label="Категории ВУ"
            validateStatus={validateDriverLicenseСategories.status}
            help={validateDriverLicenseСategories.help}
          >
            {getFieldDecorator('driverLicenseСategories')(
              <Select
                name="driverLicenseСategories"
                style={{ width: 368 }}
                placeholder="Выберите категории"
                mode="multiple"
                disabled={!isEditable}
                getPopupContainer={trigger => trigger.parentNode}
              >
                {vehicleCategories &&
                  vehicleCategories.map(item => {
                    return (
                      <Option key={item.categoryKey} value={item.categoryKey}>
                        {item.categoryName}
                      </Option>
                    );
                  })}
              </Select>
            )}
          </Form.Item>
        </div>
        {selectedСategories &&
          selectedСategories.map((item, index) => (
            <div className="b-form-fields__item" key={item.categoryKey}>
              <Form.Item label={`Дата открытия категории ${item.categoryName}`}>
                {getFieldDecorator(
                  `driverLicenseСategoryStartDate_${item.categoryKey}`
                )(
                  <DatePicker
                    style={{ width: 224 }}
                    placeholder="ДД.ММ.ГГГГ"
                    format={'DD.MM.YYYY'}
                    disabled={!isEditable}
                    locale={locale}
                  />
                )}
              </Form.Item>
            </div>
          ))}
      </div>
    );
  }
}

export default filterConnect(DriverLicense, ['vehicleCategories']);
